import { useLoadScript } from "@react-google-maps/api";
import { Libraries } from "@react-google-maps/api/dist/utils/make-load-script-url.js";
import { getGoogleMapsApiKey } from "../../environment.js";
import { GoogleMapsContext } from "./GoogleMapsContext.js";

const libraries: Libraries = ["places"];

export const GoogleMapsProvider = ({
  children,
}: React.PropsWithChildren<{}>) => {
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: getGoogleMapsApiKey(),
    libraries,
  });

  return (
    <GoogleMapsContext.Provider value={{ isLoaded }}>
      {children}
    </GoogleMapsContext.Provider>
  );
};
